import Component, {ComponentAttrs} from "flarum/common/Component";
import Mithril from "mithril";
import {TagWarningComponentAttrs} from "./types";
import app from "flarum/forum/app";

export default class TagWarningMessage extends Component<TagWarningComponentAttrs> {
  oninit(vnode: Mithril.Vnode<ComponentAttrs, this>) {
    super.oninit(vnode);
  }

  view(vnode: Mithril.Vnode<ComponentAttrs, this>): Mithril.Children {
    return (
      <div className='tag-reputation-warning-container'>
        <h4>
          <i class="fas fa-exclamation-circle" style={{ marginRight: '5px' }}></i>
          {app.translator.trans('justoverclock-reputation-score.forum.tagReputationWarningTitle')}
        </h4>
        <p>
          {app.translator.trans('justoverclock-reputation-score.forum.tagReputationWarning', { count: this.attrs.reputationPoints.toString() })}
        </p>
      </div>
    );
  }
}
